import { Box, Typography } from '@mui/material';
import { styles } from '../NotFound/styles.ts';

const NotFound = () => {
  return (
    <Box sx={styles.notFound}>
      <Box sx={styles.notFoundContainer}>
        <Typography component="h1" sx={styles.notFoundH1}>
          404
        </Typography>
        <Typography component="h2" sx={styles.notFoundH2}>
          На жаль, ця сторінка не знайдена!
        </Typography>
        <Typography component="h3" sx={styles.notFoundH3}>
          Посилання може бути пошкоджено,
        </Typography>
        <Typography component="p" sx={styles.notFoundP}>
          або сторінку, можливо, видалили
        </Typography>
      </Box>
    </Box>
  );
};

export default NotFound;
